import { ReactElement, ReactNode } from 'react'
import { Stack, SxProps } from '@mui/material'

interface Props {
  children: ReactNode
  sx?: SxProps
}

/**
 * A group of toolbar buttons rendered inside the shared scene `Toolbar`. Sibling groups are
 * separated by a vertical divider (see `Toolbar`).
 */
const ToolbarGroup = ({ children, sx }: Props): ReactElement => {
  return (
    <Stack
      direction="row"
      spacing={0.25}
      alignItems="center"
      sx={[{ pointerEvents: 'all' }, ...(sx == null ? [] : Array.isArray(sx) ? sx : [sx])]}
    >
      {children}
    </Stack>
  )
}

export default ToolbarGroup
